var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-chat__message--typing"},[_vm._v(" "+_vm._s(_vm.text)+"  "),_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }